
import Vue from 'vue';
import BoxHeader from '@/components/Box/Common/Header/BoxHeader.vue';
import { APIFetchStoreRanking } from '@/api/store';
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
import {
  GetReportingSumDataByLocationFidaV2LocationRep,
  convertApiResponseForLocationReport
} from '@/api/fida';
// import { kpiListGet } from '@/util/mockData/kpiMapping';

export default Vue.extend({
  props: {
    // eslint-disable-next-line vue/require-default-prop
    lastTimeStamp: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      renderAi: false,
      modelL: 10,
      modelR: 10,
      loading: false,
      sortBy: 'rank',
      sortOrder: 'asc',
      debounceTimer: null,
      columns: [
        {
          name: 'rank',
          label: '',
          field: 'rank'
        },
        {
          name: 'store',
          label: this.$t('store'),
          field: 'title',
          sortable: false,
          align: 'left'
        },
        {
          name: 'value',
          label: this.$t('value'),
          field: 'value',
          align: 'center',
          sortable: false,
          sort: (a, b) =>
            parseInt(a.replace(/,/g, '').replace(/円|¥/g, ''), 10) -
            parseInt(b.replace(/,/g, '').replace(/円|¥/g, ''), 10)
        },
        {
          name: 'variation',
          label: this.$t('variation'),
          field: 'variation',
          align: 'center',
          sortable: true,
          sort: (a, b) => parseFloat(a) - parseFloat(b)
        }
      ],

      data: [],
      kpi: { label: this.$t('KPI.sales'), value: 'sls' },
      options: [],
      kpiListOrder: []
    };
  },
  computed: {
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getStartingPeriod',
      'getEndingPeriod',
      'getStartingCompared',
      'getEndingCompared'
    ]),
    ...mapState('user', ['kpiLabelValue']),
    allKpiOption() {
      return this.kpiListOrder.map(kpi => ({
        label: kpi.label,
        value: kpi.value
      }));
    }
  },
  watch: {
    kpi() {
      this.triggerLoad();
    },
    kpiLabelValue: {
      immediate: true,
      handler(newValue) {
        this.setKpiOptions(newValue);
      }
    },
    lastTimeStamp() {
      this.triggerLoad();
    }
  },

  async created() {
    this.setKpiOptions(this.kpiLabelValue);
  },
  async mounted() {
    const checkRenderAi = setInterval(() => {
      if (window['renderAi']) {
        this.renderAi = true;
        clearInterval(checkRenderAi);
      }
    }, 300);
  },
  methods: {
    triggerLoad() {
      if (!this.kpi?.value) return;
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.loadKData();
      }, 300); // wait 300ms → avoids double API calls
    },
    setKpiOptions(kpiLabelValue) {
      if (!Array.isArray(kpiLabelValue) || !kpiLabelValue.length) return;
      this.kpiListOrder = [...kpiLabelValue];
      this.options = this.allKpiOption;
      this.kpi = this.options[0];
      this.triggerLoad();
    },
    toggleSort(column) {
      if (this.sortBy === column) {
        // Toggle between ascending and descending
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        // Set new column for sorting
        this.sortBy = column;
        this.sortOrder = 'asc';
      }
      this.sortData();
    },
    sortData() {
      this.data.sort((a, b) => {
        const valA = a[this.sortBy];
        const valB = b[this.sortBy];
        if (this.sortOrder === 'asc') {
          return valA > valB ? 1 : valA < valB ? -1 : 0;
        }
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      });
    },
    isSortedBy(column, order) {
      return this.sortBy === column && this.sortOrder === order;
    },
    async loadKData() {
      if (!this.kpi?.value) return;
      this.loading = true;

      var res = await GetReportingSumDataByLocationFidaV2LocationRep({
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        compareStartDate: this.getStartingCompared,
        compareEndDate: this.getEndingCompared,
        storeCodes: this.getStoreCodesList.split(','),
        kpiTypes: this.kpi.value.split(','),
        frequency: 'all'
      });
      const storesList = store.getters['user/getStoresCodeNameList'];

      const data = await convertApiResponseForLocationReport(
        res,
        this.kpi.value,
        storesList,
        this.getStartingPeriod,
        this.getEndingPeriod
      );
      const limit = 10;
      this.data =
        data?.length < limit
          ? [
              ...data,
              ...new Array(limit - data.length).fill({
                storeCode: '-',
                store: '-',
                value: '-',
                variation: '-',
                title: '-'
              })
            ]
          : data;
      data.forEach((row, index) => {
        row.index = index + 1;
      });

      this.loading = false;
    }
  }
});
